import PropTypes from 'prop-types';

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import {withTheme} from '@material-ui/core/styles';

import Cost from 'common/components/Cost';
import poweredByStripe from 'ondemand/icons/powered_by_stripe.svg';

class StripeCheckoutModal extends React.Component {
  static displayName = 'StripeCheckout';

  static propTypes = {
    amount: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    onToken: PropTypes.func.isRequired,
    stripe: PropTypes.object.isRequired,  // A fully instantiated stripe SDK object
    theme: PropTypes.object.isRequired,
  };

  state = {
    card: null,
    error: '',
  };

  _createToken = (e) => {
    e.preventDefault();
    this.props.stripe.createToken(this.state.card).then((result) => {
      if (result.error) {
        this.setState({error: result.error.message});
      } else {
        this.props.onToken({id: result.token.id});
      }
    });
  }

  _mountCard = () => {
    // Create an instance of Stripe Elements
    const elements = this.props.stripe.elements();
    // Create an instance of the card Element.
    const card = elements.create('card', {
      style: {
        base: {
          color: this.props.theme.palette.text.primary,
          fontFamily: this.props.theme.typography.body1.fontFamily,
        },
        invalid: {
          color: this.props.theme.palette.error.main,
        }
      }
    });
    // Add an instance of the card Element into the `card-element` <div>.
    card.mount('#card-element');
    this.setState({card});
  }

  render = () => (
    <Dialog
      open
      onClose={this.props.onClose}
      onEntered={this._mountCard}
      fullWidth
    >
      <DialogTitle>Pay Now</DialogTitle>
      <img
        style={{position: 'absolute', top: 16, right: 8, maxWidth: '50%', height: '32px'}}
        src={poweredByStripe}
      />
      <DialogContent>
        <DialogContentText>
          Enter your Credit or Debit card info
        </DialogContentText>
        <div style={{minHeight: '40px'}}>
          <div id="card-element" />
          <Typography color="error" variant="subtitle2">
            {this.state.error}
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={this._createToken}
          color="primary"
          variant="contained"
        >
          Book Your Ride for &nbsp;<Cost amount={this.props.amount} currencyCode="USD" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withTheme(StripeCheckoutModal);



// WEBPACK FOOTER //
// ./src/ondemand/components/StripeCheckoutModal.js